import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { OnDemandNode } from "../../OnDemandNode";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";

export class OnDemandArt57NodeList extends Art57NodeList{
    getOnDemandEntities():any{
        let entitiesArray: any[] = [];
        this.children?.forEach((child: any) => {
            let onDemandEntity:any;
            if (child instanceof OnDemandNode) {
                onDemandEntity = child.getOnDemandEntity();
            } else if (child instanceof OnDemandAutoUploadNode) {
                onDemandEntity = child.getOnDemandEntities();
            }
            if (Array.isArray(onDemandEntity ) || Object.keys(onDemandEntity ).length !== 0) {
                entitiesArray.push(onDemandEntity);
            }
        })

        return entitiesArray;
    }
    
}